import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, tap, first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/takeUntil';
const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json'
    })
};


@Injectable({
  providedIn: 'root'
})
export class GameService {

  constructor(private http: HttpClient, private toastSrvc: ToastrService) { }

  /**
   * @description for initializing bet on bouncy coin server
   * @param params {"bet": number, "winningProbability": number}
   * @returns {"betId":1,"serverCommitment":"0x00"}
   */
  betInit(params): Observable<any[]> {
    return this.http.post<any>(`bet-init`, params, httpOptions)
      .pipe(tap((res) => {
        return res;
      }));
  }

  /**
   * @description for placing bet on bouncy coin server
   * @param params {"betId": number, "choosenCard": number}
   * @returns {"serverCard":8,"serverRandomness":"0x00","result":false}
   */
  placeBet(params): Observable<any[]> {
    return this.http.post<any>(`bet`, params, httpOptions)
      .pipe(tap((res) => {
        return res;
      }));
  }
}
